/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

const isNil = (val: unknown): boolean => {
    return typeof val === 'undefined' || val === null;
};

export default isNil;
